module.exports = "/_next/static/images/improve-cashflow-99c49b04fe5c0c5d1d7542461cec9330.svg";